import { createContext } from 'react';

interface AppContextInterface {
  unleashFeatureFlags: Record<string, any>;
}
export const AppContext = createContext<AppContextInterface>({
  unleashFeatureFlags: {}
});
